import { render, staticRenderFns } from "./answerResult.vue?vue&type=template&id=c67bcaa8&scoped=true&"
import script from "./answerResult.vue?vue&type=script&lang=js&"
export * from "./answerResult.vue?vue&type=script&lang=js&"
import style0 from "./answerResult.vue?vue&type=style&index=0&id=c67bcaa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67bcaa8",
  null
  
)

export default component.exports